import { GenericoTipoEnum } from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum StatusAcessoPlataforma {
  LoginInvalido = 'LoginInvalido',
  CompletarDados = 'CompletarDados',
  Sucesso = 'Sucesso',
  LiberadoCotacao = 'LiberarCotacao',
}

export class StatusAcessoPlataformaEnum extends GenericoTipoEnum<StatusAcessoPlataforma> {
  static readonly LoginInvalido = new StatusAcessoPlataformaEnum(StatusAcessoPlataforma.LoginInvalido, 'Login inválido');
  static readonly CompletarDados = new StatusAcessoPlataformaEnum(StatusAcessoPlataforma.CompletarDados, 'Completar dados');
  static readonly Sucesso = new StatusAcessoPlataformaEnum(StatusAcessoPlataforma.Sucesso, 'Sucesso');
  static readonly LiberadoCotacao = new StatusAcessoPlataformaEnum(StatusAcessoPlataforma.LiberadoCotacao, 'Liberado cotação');
}
